<template>
  <el-dialog
    title="编辑"
    :visible.sync="dialogVisible"
    destroy-on-close
    :before-close="handleClose"
    width="500px"
  >
    <!--form-->
    <el-form
      ref="modelForm"
      :model="modelForm"
      label-width="100px"
      :label-position="labelPosition"
      :rules="modelFormRules"
      v-loading="formLoading"
    >
      <el-form-item label="选择型号">
        <el-select
          v-model="modelForm.model"
          placeholder="请选择"
          style="width: 100%"
          filterable
          remote
          reserve-keyword
          :remote-method="remoteMethod"
          :loading="selectLoading"
          @change="selectModel"
        >
          <el-option
            v-for="item in modelList"
            :key="item.modelId"
            :label="item.modelName"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="型号名称" prop="modelName">
        <el-input
          clearable
          v-model.trim="modelForm.modelName"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="型号ID" prop="modelId">
        <el-input
          clearable
          v-model.trim="modelForm.modelId"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="小程序型号" prop="modelList">
        <el-input
          clearable
          v-model.trim="modelForm.modelList"
          type="textarea"
        ></el-input>
      </el-form-item>
      <!--switch 是否默认-->
      <el-form-item label="是否默认">
        <el-switch
          v-model="modelForm.isDefault"
          :activeValue="1"
          :inactiveValue="0"
        ></el-switch>
      </el-form-item>
    </el-form>
    <!--footer-->
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { resonFaultGetModel, modelAdapterSave } from "@/api/api";
export default {
  name: "modelAdapterEdit",
  data() {
    return {
      formLoading: false,
      dialogVisible: false,
      labelPosition: "right",
      modelForm: {},
      modelFormRules: {
        modelName: [
          { required: true, message: "请输入型号名称", trigger: "blur" }
        ],
        modelId: [{ required: true, message: "请输入型号ID", trigger: "blur" }],
        modelList: [
          { required: true, message: "请输入小程序型号", trigger: "blur" }
        ]
      },
      modelList: [],
      selectLoading: false
    };
  },
  methods: {
    initData() {
      this.modelForm = {};
    },
    handleClose() {
      this.dialogVisible = false;
    },
    open(info) {
      this.modelForm = info || {};
      this.dialogVisible = true;
    },
    remoteMethod(query) {
      console.log(query);
      const params = {
        modelName: query,
        state: 1
      };
      resonFaultGetModel(params).then(resp => {
        if (resp.data.status == 100) {
          this.modelList = resp.data.results;
        }
      });
    },
    selectModel(e) {
      this.modelForm.modelId = e.modelId;
      this.modelForm.modelName = e.modelName;
    },
    onSubmit() {
      this.$refs["modelForm"].validate(valid => {
        if (valid) {
          this._save();
        }
      });
    },
    _save() {
      this.formLoading = true;
      modelAdapterSave(this.modelForm)
        .then(resp => {
          if (resp.data.status == 100) {
            this.formLoading = false;
            this.$message({
              message: "保存成功",
              type: "success"
            });
            this.handleClose();
            this.$emit("refresh");
          } else {
            this.formLoading = false;
            this.$message({
              message: resp.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.formLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// edit.vue?41210263